import Vue from 'vue'
import axios from 'axios'

import {
  SYNC_ALL_FOR_SONG,
  SYNC_CREATE,
  SYNC_UPDATE,
  SYNC_DELETE
} from '../actions'

import {
  CLEAR_STORE,
  SYNC_LOADING,
  SYNC_SUCCESS,
  SYNC_ERROR,
  SYNC_SET,
  SYNCS_SET
} from '../mutations'

export default {
  state: {
    status: '',
    syncs: [],
    sync: {}
  },

  getters: {
  },

  mutations: {
    [SYNC_LOADING]: (state) => {
      state.status = 'loading'
    },
    [SYNC_SUCCESS]: (state) => {
      state.status = 'success'
    },
    [SYNC_ERROR]: (state) => {
      state.status = 'error'
    },
    [SYNC_SET]: (state, resp) => {
      Vue.set(state, 'sync', resp)
    },
    [SYNCS_SET]: (state, resp) => {
      Vue.set(state, 'syncs', resp)
    },
    [CLEAR_STORE]: (state) => {
      Vue.set(state, 'sync', {})
      Vue.set(state, 'syncs', [])
    }
  },

  actions: {
    [SYNC_ALL_FOR_SONG]: ({
      commit,
      dispatch
    }, songId) => {
      commit(SYNC_LOADING)

      axios({
        url: 'songs/' + songId + '/syncs'
      })
        .then(resp => {
          commit(SYNC_SUCCESS)
          commit(SYNCS_SET, resp.data.data)
        })
        .catch(resp => {
          commit(SYNC_ERROR)
        })
    },

    [SYNC_CREATE]: ({
      commit,
      dispatch
    }, { songId, data }) => {
      return new Promise(function (resolve, reject) {
        commit(SYNC_LOADING)
        commit(SYNC_SET, {})

        axios({
          method: 'post',
          url: 'songs/' + songId + '/syncs',
          data: data
        })
          .then(resp => {
            commit(SYNC_SUCCESS)
            commit(SYNC_SET, resp.data.data)
            dispatch(SYNC_ALL_FOR_SONG, songId)
            resolve(resp.data.data)
          })
          .catch(resp => {
            commit(SYNC_ERROR)
            reject(resp)
          })
      })
    },

    [SYNC_UPDATE]: ({
      commit,
      dispatch
    }, {
      id,
      data,
      songId
    }) => {
      commit(SYNC_LOADING)
      commit(SYNC_SET, {})
      axios({
        method: 'put',
        url: 'syncs/' + id,
        data: data
      })
        .then(resp => {
          commit(SYNC_SUCCESS)
          commit(SYNC_SET, resp.data.data)
          dispatch(SYNC_ALL_FOR_SONG, songId)
        })
        .catch(resp => {
          commit(SYNC_ERROR)
        })
    },

    [SYNC_DELETE]: ({
      commit,
      dispatch
    }, { id, songId }) => {
      return new Promise(function (resolve, reject) {
        commit(SYNC_LOADING)

        axios({
          method: 'delete',
          url: 'syncs/' + id
        })
          .then(resp => {
            commit(SYNC_SET, {})
            dispatch(SYNC_ALL_FOR_SONG, songId)
            resolve(resp)
          })
          .catch(resp => {
            commit(SYNC_ERROR)
            reject(resp)
          })
      })
    }
  }
}
